import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export const ProtectedRoute = () => {
    const isLoggedIn = useAuthStore(state => state.isLoggedIn);

    // If they aren't logged in, boot them to the login page
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // If they are logged in, render the child routes
    return <Outlet />;
};